import {FC, useState} from "react";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";
import {Input} from "@ventumsoftware/react-toolkit";
import {useApiCall} from "../../../../lib/src/api";
import {config} from "../../config";

export const AddFolderModal: FC<{ teamSpaceId: string, onFinished: () => void, parentItemId?: string }> = (props) => {
  const { documentations } = useApiCall(config)
  const [name, setName] = useState<string>('')

  const save = async () => {
    await documentations.addFolder(
      props.teamSpaceId,
      name,
      'folder',
      props.parentItemId ? props.parentItemId : undefined
    )
    props.onFinished()
  }

  return <div>
    <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </div>
}